import { inject } from '@angular/core';
import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SnackBarService } from './services/snackbar.service';

/**
 * Shows the reason the API gives when it refuses a request with 409 - a plain text such as "Project 0001234 is already
 * ordered. It cannot be changed." - instead of the generic error message of the component. The error is passed on
 * unchanged, so the component's own handling still runs (its generic snackbar does not replace this message).
 */
export const conflictInterceptor: HttpInterceptorFn = (req, next) => {
  const snackBarService = inject(SnackBarService);
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 409 && typeof error.error === 'string' && error.error.trim() !== '') {
        snackBarService.conflict(error.error.trim());
      }
      return throwError(() => error);
    })
  );
};
